module.exports = __webpack_public_path__ + "img/document-reject-3.8cfe9411.svg";